<template>
  <v-container fluid>
    <v-layout row wrap text-xs-center>
      <v-flex xs12 sm8 offset-sm2 md6 offset-md3 mt-8 class="mt-8">
        <h1 m-8>Disfruta de todos los contenidos de Planet Horror</h1>
      </v-flex>
      <v-flex xs12 sm8 offset-sm2 md6 offset-md3 class="mt-8">
        <span class="subtitle">Accede a todos los contenidos exclusivos de Planet Horror a través de una suscripción anual</span>
      </v-flex>

      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card class="justify-center">
          <img class="align-center" src="@/assets/logo.jpg" alt="">
          <v-flex xs10 offset-xs1 sm8 offset-sm2 md6 offset-md3 class="text-xs-center">
            <h2>Descarga la app de Planet Horror para una mejor experiencia de usuario</h2>
              <a href="https://itunes.apple.com/es/app/planet-horror/id1457682357?mt=8" target="_blank">
              <img class="button-appstore" src="/ios.png"></a>
          </v-flex>
          <v-btn color="primary" class="align-center-btn" width="340px"
            @click="redirect(); dialog = false;">Ok</v-btn>
        </v-card>
      </v-dialog>

      <Loader :dialog=loading></Loader>

      <v-flex xs6 sm4 offset-sm2 md3 offset-md3 class="mt-4">
        <v-radio-group v-model="planSelector" :mandatory="false">
          <v-radio label="Suscripción anual" class="mt-4" color="black" :value="planSelector"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs6 class="mt-4">
        <v-flex xs6 sm4 offset-sm2 md3 offset-md3>
          <h3 class="mt-8" :class="{sanvalentin: discountId === 'VALENTIN2020'}">{{ recurringPayment }}</h3>
        </v-flex>
      </v-flex>

      <v-flex x12 sm8 offset-sm2 md6 offset-md3>
        <v-card>
          <v-flex xs10 offset-xs1 v-if="!membership || (source == 'stripe')">
            <form @submit.prevent="pay" id="payment-form">
              <div class="form-row">
                <label for="card-element">
                  Tarjeta de crédito o de débito
                </label>
                <div id="card-element" ref=cardElement></div>

                <!-- Used to display Element errors. -->
                <v-layout column>
                  <v-flex>
                    <v-alert type="error" dismissible v-if="error" v-model="alert">
                      {{ error }}
                    </v-alert>
                  </v-flex>
                </v-layout>
              </div>
            </form>

              <!-- <v-form ref="discountForm"> -->
                <v-flex style="display: inline-block;" xs6 class="text-xs-center" v-if="discountId !== 'VALENTIN2020'">
                  <v-text-field :value="discountId" @input="setDiscountId($event); getDiscount()" placeholder="Código de descuento"></v-text-field>
                </v-flex>
                <v-flex style="display: inline-block;" xs2 class="text-xs-center" v-if="discountId !== 'VALENTIN2020'">
                  <!-- <v-btn v-if="!membership" @click="getDiscount"
                    fullwidth flat>Aplicar descuento</v-btn> -->
                  <v-icon v-if="discountId && discountValid">done</v-icon>
                  <v-icon v-if="discountId && !discountValid">clear</v-icon>
                </v-flex>

                <v-flex v-if="planSelector" style="display: inline-block;" class="text-xs-center" xs4 mt-1>
<!--                   <v-btn
                    v-if="!membership && plan === planSelector"
                    @click.stop="pay()"
                    color="primary"
                    :disabled="loading"
                    >Reactivar Suscripción</v-btn> -->
                  <v-btn
                    v-if="membership && plan !== planSelector"
                    @click.stop="pay()"
                    color="primary"
                    :disabled="loading"
                    >Actualizar Suscripción</v-btn>
                  <v-btn
                    v-if="!membership"
                    @click.stop="pay()"
                    color="primary"
                    :disabled="loading"
                    >Activar Suscripción</v-btn>
                </v-flex>
                <v-flex v-if="discountValid && discountId !== 'VALENTIN2020'"
                  style="display: inline-block;" xs12 mb-2 class="text-xs-center">
                  <strong>Tienes un {{discount.percent_off}}% de descuento para tu primer año de suscripción, en total se cargarán {{ discount.percent_off | getDiscount }}€.
                  </strong>
                  <strong>
                    En los años posteriores tu suscripción se renovará automáticamente según la tarifa vigente.
                  </strong>
                </v-flex>
                <v-flex class="message-sanvalentin" v-else-if="discountId === 'VALENTIN2020'">
                  <p>En San Valentín, suscríbete con un 15% de descuento. Solo <b>16,99€/año.</b> En los años posteriores, se renovará automáticamente según la tarifa vigente en ese momento.</p>
                </v-flex>
                <v-flex v-else
                  style="display: inline-block;" xs12 mb-2 class="text-xs-center">
                  Si dispones de un código de descuento introdúcelo y el primer año se aplicará un descuento a tú suscripción. En los años posteriores tu suscripción se renovará automáticamente según la tarifa vigente.
                </v-flex>
              <!-- </v-form> -->

          </v-flex>
        </v-card>
        <v-btn flat
          v-if="membership && plan === planSelector"
          @click.stop="cancel()"
          color="primary"
          :disabled="loading"
          >Cancelar Subscription</v-btn>
        <v-btn flat
          v-else-if="membership"
          :to="{name: 'Contact', hash: '#cancelacion'}"
          color="primary"
          :disabled="loading"
          >Si quieres cancelar tú suscripción pulsa aquí</v-btn>
      </v-flex>

<!--       <v-flex v-if="!membership || (source == 'paypal')"
        x12 sm8 offset-sm2 md6 offset-md3 mt-4 class="text-xs-center">
        <v-card v-if="link || (!link && !membership)" color="grey lighten-3">
          <v-flex xs10 offset-xs1 class="text-xs-center">
            <img src="@/assets/paypal.svg" class="paypal-img"></img>
            <v-btn v-if="link && source == 'paypal'" @click="paypalApproveSubscription"
              :disabled="loading"
              fullwidth flat>Activar Suscripción con Paypal</v-btn>
            <v-btn v-if="!link && !membership" @click="paypalCreateSubscription"
              :disabled="loading"
              fullwidth flat>Activar Suscripción con Paypal</v-btn>
          </v-flex>
        </v-card>
      </v-flex> -->

<!--       <v-flex v-if="!membership || (source == 'coupon')"
        x12 sm8 offset-sm2 md6 offset-md3 mt-4 class="text-xs-center">
        <v-card v-if="!membership" color="grey lighten-3">
          <v-flex xs10 offset-xs1 class="text-xs-center">
            <v-form ref="couponForm" v-model="couponValid">
              <v-text-field :rules="rules" :value="couponId" @input="toUpperCase" placeholder="Código promocional"></v-text-field>
              <v-btn v-if="!membership" @click="setCoupon"
                :disabled="!couponValid"
                fullwidth flat>Código promocional</v-btn>
            </v-form>
          </v-flex>
        </v-card>
      </v-flex> -->

<!--       <v-flex x12 sm8 offset-sm2 md6 offset-md3 mt-4 class="text-xs-center">
        <v-btn @click="verifyReceiptEndpointIos"
          :disabled="loading"
          :loading="loading"
          fullwidth flat>Test: Verificar recibo iOS</v-btn>

        <v-btn @click="verifyReceipt"
          :disabled="loading"
          :loading="loading"
          fullwidth flat>Test: Verificar subscripcion iOS</v-btn>
      </v-flex>

      <v-flex v-if="membership && (source == 'iOS inApp')"
        x12 sm8 offset-sm2 md6 offset-md3 mt-4
        class="text-xs-center">
        <v-btn fullwidth flat>Suscripción realizada desde un dispositivo iOS</v-btn>
      </v-flex> -->



<!--       <v-flex x12 sm8 offset-sm2 md6 offset-md3 mt-4 class="text-xs-center">
        <v-btn @click="verifyReceiptEndpointAndroid"
          :disabled="loading"
          :loading="loading"
          fullwidth flat>Verificar recibo Android</v-btn>
      </v-flex>
      <v-flex x12 sm8 offset-sm2 md6 offset-md3 mt-4 class="text-xs-center">
        <v-btn @click="verifyReceiptAndroid"
          :disabled="loading"
          :loading="loading"
          fullwidth flat>Check recibo Android</v-btn>
      </v-flex>

      <v-flex v-if="membership && (source == 'Android inApp')"
        x12 sm8 offset-sm2 md6 offset-md3 mt-4
        class="text-xs-center">
        <v-btn fullwidth flat>Suscripción realizada desde un dispositivo Android</v-btn>
      </v-flex> -->

    </v-layout>
  </v-container>
</template>

<script>
import { stripe, elements, fun, stripePlan, recurringPayment, recurringPaymentDiscount } from '@/config'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import receiptData from '@/data/receiptData.json'
import googleReceiptData from '@/data/googleReceiptData.json'
import Loader from '@/components/Loader'
const style = {
  base: {
    // Add your base input styles here. For example:
    fontSize: '16px',
    color: "#32325d"
  }
}

// Create Charge for Specfic Amount
const stripeCreateSubscription = fun.httpsCallable('stripeCreateSubscriptionX')
const stripeCancelSubscription = fun.httpsCallable('stripeCancelSubscription')
const paypalUpdateSubscription = fun.httpsCallable('paypalActivateSubscription')
const paypalCancelSubscription = fun.httpsCallable('paypalCancelSubscription')
const paypalCreateSubscription = fun.httpsCallable('paypalCreateSubscription')
const verifyReceiptEndpointIos = fun.httpsCallable('verifyReceiptEndpointIos')
const verifyReceiptEndpointAndroid = fun.httpsCallable('verifyReceiptEndpointAndroid')
const setCouponCall = fun.httpsCallable('setCouponCall')
const verifyReceipt = fun.httpsCallable('verifyReceipt')
const verifyReceiptAndroid = fun.httpsCallable('verifyReceiptAndroid')
const getCoupon = fun.httpsCallable('getCoupon')

export default {
  components: { Loader },
  data: () => ({
    planSelector: stripePlan,
    recurringPayment: recurringPayment,
    recurringPaymentDiscount: recurringPaymentDiscount,
    alert: false,
    loading: false,
    card: null,
    link: null,
    try: 0,
    dialog: false,
    rules: [
      value => !!value || 'Required.',
      value => (value || '').length === 5 || 'Máx 5 carácteres'
    ],
    couponValid: false,
    couponId: '',
    discount: null,
    discountValid: false,
    discountId: ''
  }),
  computed: {
    ...mapGetters([
      'user', 
      'userData', 
      'membership', 
      'plan', 
      'subscription', 
      'subscriptionId',  
      'source', 
      'canceled', 
      'pending'
    ]),
    error () {
      return this.$store.state.error
    }
  },
  methods: {
    ...mapActions(['getUserData', 'setInfo']),
    ...mapMutations(['setError']),
    toUpperCase ($event) {
      this.couponId = ($event || '').toUpperCase()
      return ($event || '').toUpperCase()
    },
    async pay () {
      this.loading = true
      const setupIntentFun = fun.httpsCallable('setupIntent')
      const data = await setupIntentFun({})
      console.log('clientSecret:', data)
      const {error, setupIntent} = await stripe.handleCardSetup(
        data.data.client_secret, this.card, {
        payment_method_data: { billing_details: {email: this.userData.email} }
      })

      console.log({setupIntent, error})
      if (error) {
        this.setError(error.message)
      } else {
        this.stripeCreateSubscription(setupIntent)
      }
    },
    async stripeCreateSubscription (source) {
      try {
        this.loading = true
        if (this.discountId && !this.discountValid) {
          return this.setError('El cupón de descuento no es válido')
        }
        const coupon = this.discount? this.discount.id : null
        const res = await stripeCreateSubscription({ plan: this.planSelector, source: source.payment_method, coupon });
        console.log('stripeCreateSubscription', res)
        if (res.data.status === 'active') {
          this.setInfo({info: 'La Suscripción ha sido creada', infoType: 'success'});
        } else { // process subscription
          const pi = res.data.latest_invoice.payment_intent
          console.log({pi})
          const {paymentIntent, error} = await stripe.handleCardPayment(pi.client_secret);
          console.log({paymentIntent, error})
          if (error) {
            // Display error.message in your UI.
            this.setError(error && error.message)
            console.error(error)
          } else {
            // The payment has succeeded. Display a success message.
            this.setInfo({info: 'Estamos procesando tu subscripción. En breve te informaremos.', infoType: 'success'});
          }
        }
      } catch (error) {
        console.error(error)
        this.setError(error && error.message)
      }
      this.loading = false
    },
    async cancel () {
      this.loading = true
      try {
        const res = await stripeCancelSubscription({ plan: this.subscription.id });
        this.setInfo({info: 'La Suscripción ha sido cancelada', infoType: 'success'})
      } catch (error) {
        console.error(error)
        this.setInfo({info: error && error.message})
      }
      this.loading = false
    },
    async paypalCreateSubscription (source) {
      this.loading = true
      try {
        const res = await paypalCreateSubscription({});
        if (res && res.data && res.data.links && res.data.links.length) {
          this.link = res.data.links.find(l => l.rel === 'approve')
          if (this.link) {
            window.location = (this.link.href)
            return true
          }
        } else {
          this.setInfo({info: 'Ha ocurrido un error, vuelta a intentarlo'})
        }
        this.loading = false
      } catch (error) {
        console.error(error)
        this.setError(error && error.message)
      }
      this.loading = false
    },
    async paypalApproveSubscription () {
      this.loading = true
      window.location = (this.link.href)
    },
    async paypalCancelSubscription () {
      const subscriptionId = this.subscriptionId || this.$route.query.subscription_id
      this.loading = true
      this.resetCard()
      try {
        const res = await paypalCancelSubscription({subscriptionId: subscriptionId});
        this.setInfo({info: 'La subscripcion ha sido cancelada', infoType: 'success'})
      } catch (error) {
        console.error(error)
        // this.setError(error && error.message)
        this.setInfo({info: 'Se ha producido un error al cancelar la Suscripción', infoType: 'error'})
      }
      this.loading = false
    },
    async paypalUpdateSubscription () {
      this.loading = true
      this.resetCard()
      if (this.$route.query.cancel) {
        return await this.paypalCancelSubscription()
      }
      try {
        const subscriptionId = this.subscriptionId
        const res = await paypalUpdateSubscription({subscriptionId})
        this.setInfo({info: 'La Suscripción ha sido creada', infoType: 'success'})
      } catch (error) {
        console.error(error)
        this.setInfo({info: error.message})
        this.resetCard()
      }
      this.loading = false
    },
    setCard () {
      // Create an instance of the card Element.
      this.destroyCard()
      this.card = elements.create('card', {
        hidePostalCode: true,
        style
      })

      try {
        // Add an instance of the card Element into the `card-element` <div>.
        this.card.mount(this.$refs.cardElement)

        this.card.addEventListener('change', (event) => {
          this.setError((event.error || { message: null }).message)
        });
      } catch (error) {
        this.try += 1
        console.error(this.try, error)
        if (this.card) {
          this.destroyCard()
        }
        if (this.try < 10) {
          setTimeout(() => this.setCard(), 300)
        }
      }
    },
    destroyCard() {
      // try { this.card.destroy() } catch (e) {}
      try { this.card.unmount() } catch (e) {}
      try { elements._elements.splice(0, 1) } catch (e) {}
      try { this.$refs.cardElement.innerHTML = '' } catch (e) {} 
    },
    resetCard () {
      this.try = 0
      this.destroyCard()
      this.setCard()
    },
    async verifyReceiptEndpointIos () {
      this.loading = true
      try {
        const res = await verifyReceiptEndpointIos(receiptData)
        console.log('res:', res)
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    async verifyReceiptEndpointAndroid () {
      this.loading = true
      try {
        const res = await verifyReceiptEndpointAndroid(googleReceiptData)
        console.log('res:', res)
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    async verifyReceiptAndroid () {
      this.loading = true
      try {
        const res = await verifyReceiptAndroid()
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    async verifyReceipt () {
      this.loading = true
      try {
        const res = await verifyReceipt()
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    redirect () {
      if (this.$route.query.from) {
        return this.$router.replace({
          name: 'Video',
          params: {
            id: this.$route.query.from.split('/')[2]
          }
        })
      } else {
        return this.$router.replace({ name: 'Home' })
      }
    },
    paymentSuccess () {
      this.$router.replace({ name: 'PaymentSuccess' })
    },
    async setCoupon () {
      this.loading = true
      try {
        await setCouponCall({coupon_id: this.couponId})
        this.setInfo({info: 'La Suscripción ha sido creada', infoType: 'success'})
      } catch (error) {
        this.setInfo({info: 'El cupón no es válido', infoType: 'error'})
      }
      this.loading = false
    },
    async getDiscount () {
      // this.loading = true
      try {
        console.log('discountId', this.discountId)
        const res = await getCoupon({coupon_id: this.discountId})
        this.discountValid = true
        // this.setInfo({info: 'El descuento ha sido aplicado', infoType: 'success'})
        this.discount = res.data
        console.log('RES', res)
      } catch (error) {
        this.discount = null
        console.log(error)
        this.discountValid = false
        // this.setInfo({info: 'El descuento no es válido', infoType: 'error'})
      }
      // this.loading = false
    },
    setDiscountId ($event) {
      localStorage.setItem('discountId', $event)
      this.discountId = $event
      console.log([this.discountId, $event])
    }
  },
  watch: {
    error (value) {
      if (value) {
        this.loading = false
        this.alert = true
      } else {
        this.alert = false
      }
    },
    alert (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    },
    plan (value) {
      if (value && this.source === 'stripe') {
        this.planSelector = value
      }
    },
    async membership (value) {
      if (value) {
        this.$router.replace({ name: 'PaymentSuccess' })
      }
    },
    async subscription (value) {
      if (this.source === 'paypal' && value && value.links) {
        this.link = this.subscription.links.find(l => l.rel === 'approve')
      }
      const subscriptionId = this.$route.query.subscription_id
      if (this.source === 'paypal' && this.pending && subscriptionId) {
        const query = Object.assign({}, this.$route.query);
        delete query.subscription_id;
        this.$router.replace({ query });
        this.loading = true
        await this.paypalUpdateSubscription()
        this.loading = false
      }
    },
    async '$route' (to, from, other) {
      console.log('--WATCH--', 'route')
      console.log('NAME-ID', to.name, to.params.id)
      if (this.source === 'paypal' && this.pending && subscriptionId) {
        this.loading = true
        await this.paypalUpdateSubscription()
        this.loading = false
      }
    }
  },
  async mounted () {
    if (this.subscription && this.$route.query.from) {
      return this.$router.replace({
        name: 'Video',
        params: {
          id: this.$route.query.from.split('/')[2]
        }
      })
    }

    this.setDiscountId(localStorage.getItem('discountId'))
    if (this.discountId) this.getDiscount()
    this.setCard()
    if (this.source === 'paypal' && this.subscription) {
      this.link = (this.subscription.links || []).find(l => l.rel === 'approve')
    }
    const subscriptionId = this.$route.query.subscription_id
    if (this.source === 'paypal' && this.pending && subscriptionId) {
      this.loading = true
      await this.paypalUpdateSubscription()
      this.loading = false
    }
    return getCoupon({wakeup: true})
  },
  beforeDestroy () {
    this.destroyCard()
    this.loading = false
  },
  activated () {
    // window.adperf_conversion(284);
  },
  filters: {
    fixed2: function (value) {
      if (!value) return ''
      return Number(value).toFixed(2)
    },
    getDiscount: function (value) {
      if (!value) return ''
      return (19.99 - 19.99 * Number(value) / 100).toFixed(2)
    }
  }
}
</script>

<style scoped>
  .sanvalentin {
    text-decoration: line-through;
  }
  .button-appstore {
    width: 150px;
    margin: auto 10px;
  }
  .paypal-img {
    vertical-align: middle;
  }
  .subtitle {
    font-size: 16px;
  }
  .mt-8 {
    margin-top: 40px;
  }
  .mt-4 {
    margin-top: 20px;
  }
  .align-center {
    margin-top: 20%;
    margin-left: calc(50% - 165px);
  }
  .align-center-btn {
    display: block;
    margin-left: calc(50% - 136px);
  }
  .message-sanvalentin {
    padding-bottom: 30px !important;
    padding-top: 30px !important;
  }
</style>

<style>
  .StripeElement {
    box-sizing: border-box;

    height: 40px;

    padding: 10px 12px;

    border: 1px solid transparent;
    border-radius: 4px;
    background-color: white;

    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
  }

  .StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }

  .StripeElement--invalid {
    border-color: #fa755a;
  }

  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }
  .align-center-btn * {
    width: 240px;
  }
</style>
